import script from "./BikeSP.vue?vue&type=script&setup=true&lang=js"
export * from "./BikeSP.vue?vue&type=script&setup=true&lang=js"

import "./BikeSP.vue?vue&type=style&index=0&id=1fa95a41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa95a41"]])

export default __exports__